import { c as createStore } from './index2.js';

const iframeInputStylesStore = createStore({
    focused: {
        boxShadow: '',
        border: '',
    },
    focusedAndInvalid: {
        boxShadow: '',
        border: '',
    },
    fontStyles: {
        fontFamily: '',
        fontSize: '',
        fontWeight: '',
        lineHeight: '',
        margin: '',
        padding: '',
    },
});
const { state: iframeInputStyles, set: iframeInputStylesSet, } = iframeInputStylesStore;

export { iframeInputStyles as a, iframeInputStylesSet as i };
